var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplateBanner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 959,
    height: 76,
    viewBox: "0 0 959 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2728_5577)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -160,
    width: 1280,
    height: 173,
    fill: "#001B9C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 812,
    cy: 333.5,
    rx: 384,
    ry: 390.5,
    fill: "#00DD97"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 817.5,
    cy: 161.5,
    rx: 191.5,
    ry: 171.5,
    fill: "#001B9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2728_5577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateBanner);
export default __webpack_public_path__ + "static/media/template-banner.fdfe89da44d9dc9d20cac2a3d4e5d326.svg";
export { ForwardRef as ReactComponent };